module.exports = "<app-par-nav-tab></app-par-nav-tab>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/par-nav/par-nav.component.html
// module id = ./src/app/components/par-nav/par-nav.component.html
// module chunks = main